import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing p-30" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_9 = {
  key: 0,
  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
  type: "submit"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "mb-3 justify-content-center"
}
const _hoisted_13 = {
  key: 0,
  class: "mb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_center = _resolveComponent("center")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      ref: "redevanceForm",
      onSubmit: _ctx.genererRedevances,
      "validation-schema": _ctx.redevanceSchema
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                _createTextVNode(" Commune "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "commune",
                modelValue: _ctx.communeSelect,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.communeSelect) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, {
                    options: _ctx.communesOptions,
                    searchable: true,
                    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.communeChange($event))),
                    placeholder: "Rechercher une commune",
                    noResultText: "Aucun enregistrement trouvé",
                    noOptionsText: "Tapez au moins caractères caractères"
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "commune",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                _createTextVNode(" Agence "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "bureau",
                modelValue: _ctx.bureauselect,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bureauselect) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    "no-options-text": _ctx.nooptions,
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, {
                    options: _ctx.bureauxOptions,
                    placeholder: "Selectionner un bureau"
                  }), null, 16, ["no-options-text", "modelValue", "onUpdate:modelValue", "options"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "bureau",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (!_ctx.isloading)
                ? (_openBlock(), _createElementBlock("button", _hoisted_9, " Générer "))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: _normalizeClass((_ctx.resultat.length > 0) ? 'alert alert-success':'alert alert-info')
                    }, [
                      (_ctx.resultat.length == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Veuillez patienter. Votre requête est en cours de traitement..."))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(_component_center, null, {
                              default: _withCtx(() => [
                                (_ctx.resultat)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.resultat.message), 1),
                                      _cache[6] || (_cache[6] = _createTextVNode()),
                                      _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                                      _cache[8] || (_cache[8] = _createElementVNode("strong", null, "Redevances Générées:", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.resultat?.data), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]))
                    ], 2),
                    (_ctx.resultat && _ctx.resultat.length != 0)
                      ? (_openBlock(), _createBlock(_component_center, { key: 0 }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-secondary py-1 px-2 m-0",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isloading = !_ctx.isloading, _ctx.resultat = []))
                            }, " Fermé ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}